(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-finley-header]').forEach((header) => {
    const toggle = header.querySelector('[data-finley-toggle]')
    const nav = header.querySelector('[data-finley-nav]')

    if (!toggle || !nav) {
      return
    }

    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true'
      const nextState = String(!isOpen)
      toggle.setAttribute('aria-expanded', nextState)
      header.dataset.open = nextState
    })

    nav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        toggle.setAttribute('aria-expanded', 'false')
        header.dataset.open = 'false'
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-thumbs]').forEach((thumbGroup) => {
    const mainImage = thumbGroup.closest('.product-page__media')?.querySelector('[data-main-image]')
    const thumbButtons = Array.from(thumbGroup.querySelectorAll('[data-thumb-button]'))

    if (!mainImage || thumbButtons.length === 0) {
      return
    }

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const imageUrl = button.dataset.imageUrl
        const imageAlt = button.dataset.imageAlt || ''

        if (!imageUrl || mainImage.getAttribute('src') === imageUrl) {
          return
        }

        mainImage.classList.add('is-loading')
        mainImage.src = imageUrl
        mainImage.alt = imageAlt

        thumbButtons.forEach((thumbButton) => {
          const isActive = thumbButton === button
          thumbButton.classList.toggle('is-active', isActive)
          thumbButton.setAttribute('aria-pressed', String(isActive))
        })
      })
    })

    mainImage.addEventListener('load', () => {
      mainImage.classList.remove('is-loading')
    })
  })

  } catch(e) { console.error(e); }
})();
})();
